import React, { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

export function MultiSelect({ options = [], values = [], onChange, placeholder = "Seleccionar...", testId, label }) {
  const [open, setOpen] = useState(false);

  const toggle = (val) => {
    if (values.includes(val)) onChange(values.filter((v) => v !== val));
    else onChange([...values, val]);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          data-testid={testId || "multi-select-trigger"}
          className="w-full justify-between h-10 font-normal"
        >
          <span className="truncate text-left flex-1">
            {values.length === 0
              ? <span className="text-muted-foreground">{placeholder}</span>
              : <span>{values.length} seleccionado{values.length !== 1 ? "s" : ""}: {values.slice(0, 2).join(", ")}{values.length > 2 ? "..." : ""}</span>}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0" align="start">
        <Command>
          <CommandInput placeholder={`Buscar ${label || ""}...`} />
          <CommandList>
            <CommandEmpty>Sin resultados.</CommandEmpty>
            <CommandGroup>
              {options.map((opt) => {
                const checked = values.includes(opt);
                return (
                  <CommandItem
                    key={opt}
                    onSelect={() => toggle(opt)}
                    className="flex items-center gap-2 cursor-pointer"
                    data-testid={`multi-select-option-${opt}`}
                  >
                    <Checkbox checked={checked} onCheckedChange={() => toggle(opt)} />
                    <span className="flex-1">{opt}</span>
                    {checked && <Check className="h-4 w-4 text-primary" />}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
